import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Icon from '../../atoms/Icon';

var AppConfig = require('../../../config.json');

/**
 * A simple OrderFormSepaCheckbox.
 */

class OrderFormSepaCheckbox extends React.Component {
	constructor(props) {
	  super(props);
		this.handleClick = this.handleClick.bind(this);
	  this.state = {active:false, init:false};
	}
	componentDidMount() {
		if(this.props.sepa.checkbox) {
			this.setState({active:true});
		}
		this.setState({init:true});
	}


	handleClick(e) {
		var nextState = !this.state.active;
		this.setState({active:!this.state.active});
		this.props.onClick(nextState);
	}

    render () {
        return (
          <div className={`orderformsepacheckbox${this.state.active?" selected":""}`}>
            <div className="toggler">
            	<div className="toggleselect" onClick={this.handleClick}><Icon filename="selected" /></div>
            </div>
            <div className="inner">
            	<div className="desc" onClick={this.handleClick}>
	            	<div className="subline bold" style={{color:"black"}}>
	              		Ich ermächtige die Gesellschaft für digitale Bildung mbH Zahlungen von meinem Konto mittels SEPA-Lastschrift einzuziehen. Zugleich weise ich mein Kreditinstitut an, die von der Gesellschaft für digitale Bildung auf mein Konto gezogene Lastschriften einzulösen. Hinweis: Ich kann innerhalb von acht Wochen, beginnend mit dem Belastungsdatum, die Erstattung des belasteten Betrages verlangen. Es gelten dabei die mit meinem Kreditinstitut vereinbarten Bedingungen.
	              	</div>
            	</div>
            </div>
            
          </div>
        );
    }

}

OrderFormSepaCheckbox.propTypes = {
	/** Gets called when the user clicks on the item */
	onClick: PropTypes.func
}

OrderFormSepaCheckbox.defaultProps = {
	/* eslint-disable no-console */
	onClick: event => {
		console.log('You have clicked a OrderFormSepaCheckbox Component!', event.target);
	}
	
}


const mapStateToProps = (state) => {
  return {
    sepa: state.status.sepa
  }
}


export default connect(
  mapStateToProps,
  null
)(OrderFormSepaCheckbox)







// WEBPACK FOOTER //
// ./src/components/molecules/OrderFormSepaCheckbox/OrderFormSepaCheckbox.js